import rainforestLogo from "/img/integration/rainforest.png"
import { ConnectEmailPage } from "@/setup/connect/connect-email-page"
import { EmailConfigPage } from "@/setup/config/email-config-page"
import { BackToSettingsButton } from "@/setup/connect/settings-connect-layout"

export function SettingsConnectRainforestPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectEmailPage
        logo={rainforestLogo}
        logoAlt="Rainforest"
        integrationName="rainforest"
        description="Rainforest sends deduction and dispute information via email. Connect the email account(s) that receive Rainforest communications."
        redirectTo="/settings/config/rainforest"
      />
    </div>
  )
}

export function SettingsConfigRainforestPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <EmailConfigPage
        logo={rainforestLogo}
        logoAlt="Rainforest"
        integrationName="rainforest"
        displayName="Rainforest"
        connectPath="/settings/connect/rainforest"
      />
    </div>
  )
}
